export const setExpirationData = (dataValue: string) => {
    localStorage.setItem('expirationData', dataValue);  
}